import { replace } from 'react-router-redux';
import { getProductList, getRecommendCourse, getProduct, transferProduct, getActivity } from 'actions/product';
import { getMemberData, checkMemberData } from 'actions/member';
import { getCouponList } from 'actions/coupon';
import { openGlobalModal } from 'actions/modal';

export default store => ({
	path: 'product',
	indexRoute: {
		getComponent: (nextState, cb) =>
			require.ensure(
				[],
				require => {
					const component = require('./Home').default;
					cb(null, component);
				},
				'Product',
			),
		onEnter: () => {
			window.scrollTo(0, 0);
			store.dispatch(getMemberData());
			const { auth: { token: { accessToken } } } = store.getState();
			const { members: { emailVerify } } = store.getState();
			if (accessToken === '') {
				store.dispatch(replace({ pathname: '/login' }));
			} else {
				if (emailVerify === 0) {
					store.dispatch(openGlobalModal('verifyEmailNotyet'));
				}
				store.dispatch(getProductList());
			}
		},
	},
	childRoutes: [
		{
			path: 'add',
			indexRoute: {
				getComponent: (nextState, cb) =>
					require.ensure(
						[],
						require => {
							const component = require('./Add').default;
							cb(null, component);
						},
						'add',
					),
				onEnter: () => {
					store.dispatch(getMemberData());
					store.dispatch(checkMemberData());
					const { auth: { token: { accessToken } } } = store.getState();
					const {
						members: {
							mobileVerify,
						},
					} = store.getState();
					if (accessToken === '') {
						store.dispatch(replace({ pathname: '/login' }));
					} else if (accessToken !== '') {
						if (mobileVerify === 0) {
							store.dispatch(openGlobalModal('verifyMobileNotyet'));
						}
					}
				},
			},
		},
		{
			path: 'transfer/:id',
			indexRoute: {
				getComponent: (nextState, cb) =>
					require.ensure(
						[],
						require => {
							const component = require('./Transfer').default;
							cb(null, component);
						},
						'transfer',
					),
				onEnter: ({ params, location: { query: { status = '' } } }) => {
					const { auth: { token: { accessToken } } } = store.getState();
					if (accessToken === '') {
						store.dispatch(replace(`/login?id=${params.id}&status=${status}`));
					} else {
						store.dispatch(transferProduct(params.id, status));
					}
				},
			},
		},
		{
			path: ':id',
			indexRoute: {
				getComponent: (nextState, cb) =>
					require.ensure(
						[],
						require => {
							const component = require('./Info').default;
							cb(null, component);
						},
						'info',
					),
				onEnter: ({ params }) => {
					store.dispatch(getProduct(params.id));
				},
			},
			childRoutes: [
				{
					path: 'service',
					indexRoute: {
						getComponent: (nextState, cb) =>
							require.ensure(
								[],
								require => {
									const component = require('./Service').default;
									cb(null, component);
								},
								'service',
							),
						onEnter: ({ params }) => {
							store.dispatch(getProduct(params.id));
						},
					},
				},
				{
					path: 'course',
					indexRoute: {
						getComponent: (nextState, cb) =>
							require.ensure(
								[],
								require => {
									const component = require('./Course').default;
									cb(null, component);
								},
								'course',
							),
						onEnter: ({ params }) => {
							store.dispatch(getProduct(params.id));
							store.dispatch(getRecommendCourse(params.id));
						},
					},
				},
				{
					path: 'coupon',
					indexRoute: {
						getComponent: (nextState, cb) =>
							require.ensure(
								[],
								require => {
									const component = require('./Coupon').default;
									cb(null, component);
								},
								'course',
							),
						onEnter: ({ params }) => {
							store.dispatch(getProduct(params.id));
							store.dispatch(getCouponList());
						},
					},
				},
				{
					path: 'activity',
					indexRoute: {
						getComponent: (nextState, cb) =>
							require.ensure(
								[],
								require => {
									const component = require('./Activity').default;
									cb(null, component);
								},
								'activity',
							),
						onEnter: ({ params }) => {
							store.dispatch(getActivity(params.id));
						},
					},
				},
			],
		},
	],
});



// WEBPACK FOOTER //
// ./src/routes/Product/index.js